import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsFacilites({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M4 8v1.6h8V8c0-.88.72-1.6 1.6-1.6h.8A2.4 2.4 0 0012 4H4a2.4 2.4 0 00-2.4 2.4h.8C3.28 6.4 4 7.12 4 8zm10.4-.8h-.8a.8.8 0 00-.8.8v2.4H3.2V8a.8.8 0 00-.8-.8h-.8a1.6 1.6 0 10-.8 2.98v3.02c0 .22.18.4.4.4h1.6a.4.4 0 00.4-.4v-.4h9.6v.4c0 .22.18.4.4.4h1.6a.4.4 0 00.4-.4v-3.02a1.6 1.6 0 00-.8-2.98z" />
    </svg>
  );
}

SvgSettingsFacilites.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsFacilites.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsFacilites svgRef={ref} {...props} />
));
export default ForwardRef;
